import { t as getStaticHeader } from "./header-Coj1pAb8.mjs";
//#region src/namespaces/gatsby-client.ts
const GatsbyClient = { getHeader: getStaticHeader };
//#endregion
export { GatsbyClient };
